import { render, staticRenderFns } from "./PXSurveyEvaluationPage.vue?vue&type=template&id=898d0dc2&scoped=true"
import script from "./PXSurveyEvaluationPage.vue?vue&type=script&lang=js"
export * from "./PXSurveyEvaluationPage.vue?vue&type=script&lang=js"
import style0 from "./PXSurveyEvaluationPage.vue?vue&type=style&index=0&id=898d0dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d0dc2",
  null
  
)

export default component.exports